// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3sbj2","title":"card_title__1F-oV","inActive":"card_inActive__34n03"};